import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import loader from "../../assets/loader.json";
import { DataGrid } from "@mui/x-data-grid";
import { FiDownload } from "react-icons/fi";
import * as XLSX from "xlsx";

const Wallet = ({ id, wallet, addr, canWrite }) => {
  const [walletData, setWalletData] = useState([]);
  const [user_address, setuser_address] = useState([]);
  useEffect(() => {
    if (wallet) {
      setWalletData(wallet);
    }
  }, [wallet]);

  // Create rows
  const rows = walletData.map((item, index) => ({
    id: index + 1,
    symbol: item.symbol || "-",
    amount: item.amount ?? 0,
    hold: item.hold ?? 0,
    total: item.total ?? 0,
    withdrawal: item.withdraw ?? 0,
    withdrawalhold: item.withdrawhold ?? 0,
    createdAt: item.createdAt
      ? new Date(item.createdAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
      : "N/A", // Fallback if date is not present
  }));

  const columns = [
    // { field: "id", headerName: "S.No", flex: 0.25, minWidth: 50 },
    { field: "symbol", headerName: "Symbol", flex: 1, minWidth: 150 },
    { field: "amount", headerName: "Amount", flex: 1, minWidth: 100 },
    { field: "hold", headerName: "Hold", flex: 1, minWidth: 100 },
    { field: "total", headerName: "Total", flex: 1, minWidth: 100 },
    { field: "withdrawal", headerName: "withdrawal", flex: 1, minWidth: 100 },
    { field: "withdrawalhold", headerName: "withdrawalhold", flex: 1, minWidth: 100 },
    // { field: "createdAt", headerName: "Created At", flex: 1, minWidth: 150 },
  ];

  const handleExport = () => {
    if (!walletData.length) return;

    const exportRows = walletData.map((item, index) => ({
      "S.No": index + 1,
      Symbol: item.symbol || "-",
      Amount: item.amount ?? 0,
      Hold: item.hold ?? 0,
      Total: item.total ?? 0,
      "Created At": item.createdAt
        ? new Date(item.createdAt).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
        : "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(exportRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Wallet");
    XLSX.writeFile(wb, `Wallet_${id || "user"}.xlsx`);
  };

  const style = {
    height: 100,
    width: 100,
    margin: "auto",
    alignItems: "center",
  };

  return !wallet ? (
    <Lottie animationData={loader} style={style} loop={true} />
  ) : (
    <div className="w-[80vw] mx-auto h-full">
      <div className="w-full mt-[10px] border">
        <div className="flex justify-between p-5 text-blue-900 font-bold">
          <h1 className="text-2xl">Wallet</h1>
          <button
            onClick={handleExport}
            className="flex items-center gap-2 px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded shadow text-sm"
          >
            <FiDownload className="w-5 h-5" />
            {/* Export */}
          </button>
        </div>
        <div className="flex justify-between p-5 text-blue-900 font-bold">
          <h1 className="text-1xl">Address : {addr?.[0]?.address || '-'}</h1>
        </div>
        <DataGrid
          columns={columns}
          rows={rows}
          getRowId={(row) => row.id}
          pageSize={10}
          autoHeight
          rowHeight={40}
        />
      </div>
    </div>
  );
};

export default Wallet;
